import React, { useState, useRef, useCallback } from "react";

import { Images } from "../../assets/common";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import { useDispatch } from "react-redux";
import { Box, Tabs, Tab, Stack, Typography, Divider } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { isOwnerId, isOwner } from "../../constants/function";
import NoData from "../../components/Nodata";
import notifier from "../../components/Notifier";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArtistProfileRow from "../../components/ArtistProfileRow";
import AddMusicToPlaylist from "../AddMusicToPlaylist";
import { addSongAction, addSongsAction } from "../../action/songs";
import ArtistMusicTab from "../ArtistMusicTab";
import ArtistGalleryTab from "../ArtistGalleryTab";
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import StarIcon from '@mui/icons-material/Star';
import SensorsIcon from '@mui/icons-material/Sensors';
import VideocamIcon from '@mui/icons-material/Videocam';
import MyLivestreamsTab from "../../pages/Library/MyLivestreamsTab";
import MyVideosTab from "../../pages/Library/MyVideosTab";

import "./index.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function ArtistContent({
  id,
  userData,
  liveChannelName = null,
  getPlayListMusic,
  playlistNft,
  initialMusic = [],
  initialPlaylists = [],
  initialNfts = [],
  initialAlbums = [],
  initialVideos = [],
  getMyMusic: parentGetMyMusic,
  getPlayLists: parentGetPlayLists,
  getNfts: parentGetNfts,
  getAlbum: parentGetAlbum,
  getVideos: parentGetVideos,
  handleTabSwitch: parentHandleTabSwitch,
  handleScroll: parentHandleScroll,
  active: parentActive = 0,
  loaded: parentLoaded = false,
  loading: parentLoading = false,
}) {
  const { t } = useTranslation("common");

  const { addBalance } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false); // Start with false to avoid duplicate loading
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const [pageNo, setPageNo] = React.useState(1);
  const [musics, setMusics] = React.useState(initialMusic);

  const [playlists, setPlayLists] = React.useState(initialPlaylists);
  const [active, setActive] = React.useState(0);
  const [nftMusics, setNftMusics] = React.useState(initialNfts);
  const [albums, setAlbums] = React.useState(initialAlbums);
  const [singles, setSingles] = React.useState([]);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [topMusic, setTopMusic] = React.useState([]);
  const history = useHistory();
  const [hasMore, setHasMore] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const toggleMenu = (value, id, index, tab, isplaylist, isMusic) => {
    setSelectedAlbum(id);
    if (value && id) makeAction(value, id, index, tab, isMusic);
  };
  const makeAction = async (key, id, index, tab, isMusic) => {
    switch (key) {
      case "m2":
        if (tab === 0 && musics.length) {
          if (
            !isOwnerId(userData["_id"]) &&
            !userData["isSubscribed"] &&
            musics[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            dispatch(addSongAction(musics[index], null, true));
          }
        } else if (tab === 1) {
          if (tabIndex == 0) {
            const i = singles[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              singles[index]["music"][i]["uploader"] &&
              !singles[index]["music"][i]["uploader"]["isSubscribed"] &&
              singles[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              dispatch(addSongAction(singles[index]["music"][i], null, true));
            }
          } else {
            const i = albums[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              albums[index]["music"][i]["uploader"] &&
              !albums[index]["music"][i]["uploader"]["isSubscribed"] &&
              albums[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              dispatch(addSongAction(albums[index]["music"][i], null, true));
            }
          }
        } else if (tab === 3) {
          if (!nftMusics[index]["isSubscribed"] && nftMusics[index]["private"])
            notifier.error(t("notifier.error.toast15"));
          else dispatch(addSongAction(nftMusics[index], null, true));
        } else if (tab === 2 || tab === 5) {
          const isPlaylist = tab === 2 || tab === 5 ? true : false;
          dispatch(
            addSongAction(
              tab === 0
                ? topMusic[index]
                : tab === 1
                ? musics[index]
                : tab === 3 && nftMusics[index]["musicDetails"]
                ? nftMusics[index]["musicDetails"]
                : musics[index],
              isPlaylist ? musics["_id"] : null,
              true
            )
          );
        }

        break;
      case "m3":
        if (
          tab === 0 &&
          musics[index]["uploader"] &&
          !musics[index]["uploader"]["isSubscribed"] &&
          musics[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else if (tab === 1) {
          if (tabIndex == 0) {
            const i = singles[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              singles[index]["music"][i]["uploader"] &&
              !singles[index]["music"][i]["uploader"]["isSubscribed"] &&
              singles[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              setShowPlaylist(true);
            }
          } else {
            const i = albums[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              albums[index]["music"][i]["uploader"] &&
              !albums[index]["music"][i]["uploader"]["isSubscribed"] &&
              albums[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              setShowPlaylist(true);
            }
          }
        } else if (
          tab === 3 &&
          !nftMusics[index]["isSubscribed"] &&
          nftMusics[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else setShowPlaylist(true);
        break;
      case "m1":
        if (tab != undefined && tab === 0) {
          history.push(
            musics[index]?.nftId
              ? `/app/SongDetails/${musics[index]?.nftId}?nft=true`
              : `/app/SongDetails/${id}`
          );
        } else if (tab && tab === 1) {
          if (tabIndex == 0) {
            const i = singles[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              singles[index]["music"][i]["uploader"] &&
              !singles[index]["music"][i]["uploader"]["isSubscribed"] &&
              singles[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              history.push(
                singles[index]["music"][i]?.nftId
                  ? `/app/SongDetails/${singles[index]["music"][i]?.nftId}?nft=true`
                  : `/app/SongDetails/${id}`
              );
            }
          } else {
            const i = albums[index]["music"].findIndex(
              (obj) => obj["_id"] === id
            );
            if (
              albums[index]["music"][i]["uploader"] &&
              !albums[index]["music"][i]["uploader"]["isSubscribed"] &&
              albums[index]["music"][i]["private"]
            ) {
              notifier.error(t("notifier.error.toast15"));
            } else {
              history.push(
                albums[index]["music"][i]?.nftId
                  ? `/app/SongDetails/${albums[index]["music"][i]?.nftId}?nft=true`
                  : `/app/SongDetails/${id}`
              );
            }
          }
        } else if (
          tab &&
          tab === 3 &&
          !nftMusics[index]["isSubscribed"] &&
          nftMusics[index]["private"]
        ) {
          notifier.error(t("notifier.error.toast10"));
        } else {
          history.push(
            `/app/SongDetails/${
              nftMusics[index]["nftId"]
                ? nftMusics[index]["nftId"]
                : nftMusics[index]["_id"]
            }?nft=true`
          );
        }
        break;
      case "m26":
        if (tab === 2) {
          if (
            !isOwner(
              playlists[index]["createdByDetails"]
                ? playlists[index]["createdByDetails"]["email"]
                : ""
            ) &&
            playlists[index]["createdByDetails"] &&
            !playlists[index].isSubscribed &&
            playlists[index]["private"]
          )
            notifier.error(t("notifier.error.toast15"));
          else {
            const tempMusic = await getPlayListMusic(id);
            dispatch(addSongsAction(tempMusic, false, id, 0));
          }
        } else if (tab === 4) {
          dispatch(addSongsAction(albums[index]["music"], false, null, 0, id));
        } else if (
          !isOwner(
            playlistNft[index]["owner"]
              ? playlistNft[index]["owner"]["email"]
              : ""
          ) &&
          !playlistNft[index]["isSubscribed"] &&
          playlistNft[index]["private"]
        )
          notifier.error(t("notifier.error.toast15"));
        else {
          const tempMusic = await getPlayListMusic(id);
          // dispatch(addSongsAction(tempMusic, false, id, 0));
          tempMusic.forEach((m, index) => dispatch(addSongAction(m, id, true)));
        }
        break;
      case "m27":
        if (
          tab === 5 &&
          playlistNft[index]["owner"] &&
          playlistNft[index]["owner"]["_id"]
        )
          history.push(
            `/app/PlaylistStatics/${id}/${playlistNft[index]["owner"]["_id"]}`
          );
        else
          history.push(
            `/app/PlaylistStatics/${id}/${playlists[index]["createdBy"]}`
          );
        break;
      case "m28":
        history.push(`/app/AlbumDetail/${albums[index]["_id"]}`);
        break;
      case "m8":
        if (tab === 2 && playlists[index]["nftId"]) {
          if (
            !isOwnerId(playlists[index]["owner"]) &&
            !playlists[index]["isSubscribed"] &&
            playlists[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else
            history.push(`/app/PlaylistNftDetail/${playlists[index]["nftId"]}`);
        } else if (tab === 3) {
          if (isMusic) {
            if (
              !isOwner(
                musics[index]["owner"] ? musics[index]["owner"]["email"] : ""
              ) &&
              !musics[index]["isSubscribed"] &&
              musics[index]["private"]
            )
              notifier.error(t("notifier.error.toast9"));
            else history.push(`/app/NftDetail/${id}`);
          } else if (
            !isOwner(
              nftMusics[index]["owner"]
                ? nftMusics[index]["owner"]["email"]
                : ""
            ) &&
            !nftMusics[index]["isSubscribed"] &&
            nftMusics[index]["private"]
          )
            notifier.error(t("notifier.error.toast9"));
          else history.push(`/app/NftDetail/${nftMusics[index]["nftId"]}`);
        }
        break;
      default:
        break;
    }
  };

  const getMyMusic = async (next) => {
    // Use parent function if available to avoid duplicate API calls
    if (parentGetMyMusic) {
      return parentGetMyMusic(id, next);
    }
    // Fallback to local implementation
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        pageNo: next,
        pageSize: 15,
        id: id,
        type: "popular",
      });

      setMusics((prevMusic) => {
        return [...new Set([...prevMusic, ...response["result"]])];
      });
      setHasMore(response["result"].length > 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getAlbums = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_LIST({
        pageNo: next,
        pageSize: 15,
        id: id,
        releaseType: "albums",
      });

      setAlbums((prevMusic) => {
        return [...new Set([...prevMusic, ...response["result"]])];
      });
      setHasMore(response["result"].length > 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getSingles = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_LIST({
        pageNo: next,
        pageSize: 15,
        id: id,
        releaseType: "singles",
      });

      setSingles((prevMusic) => {
        return [...new Set([...prevMusic, ...response["result"]])];
      });
      setHasMore(response["result"].length > 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // const getPopular = async (next) => {
  //   try {
  //     setLoading(true);
  //     const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
  //       pageNo: next,
  //       pageSize: 15,
  //       id: id,
  //       type: "popular",
  //     });

  //     setMusics((prevMusic) => {
  //       return [...new Set([...prevMusic, ...response["result"]])];
  //     });
  //     setHasMore(response["result"].length > 0);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const getPlayLists = async (next) => {
    // Use parent function if available
    if (parentGetPlayLists) {
      return parentGetPlayLists(id);
    }
    // Fallback to local implementation
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        pageNo: next,
        pageSize: 15,
        id: id,
        type: "studio",
      });
      setPlayLists((prev) => {
        return [...new Set([...prev, ...response["result"]])];
      });
      setHasMore(response["result"].length > 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getNfts = async (next) => {
    // Use parent function if available
    if (parentGetNfts) {
      return parentGetNfts(id, next);
    }
    // Fallback to local implementation
    try {
      setLoading(true);
      const response = await ApiService.TOP_ALBUM_MUSIC_STUDIO_LIST({
        pageNo: next,
        pageSize: 15,
        id: id,
        type: "nft",
      });
      setNftMusics((prev) => {
        return [...new Set([...prev, ...response["result"]])];
      });
      setHasMore(response["result"].length > 0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const playAll = async (index, music) => {
    let showError = false;
    if (value === 0) {
      music[index]["artistData"].forEach((e) => {
        if (isOwnerId(e["uId"])) {
          showError = true;
        }
      });
    }
    if (
      (value === 0 || value === 1) &&
      // !isOwnerId(music[index]["createdBy"] ? music[index]["createdBy"] : "") &&
      !isOwnerId(
        music[index]["uploader"] ? music[index]["uploader"]["_id"] : ""
      ) &&
      !showError &&
      !music[index]["isSubscribed"] &&
      music[index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (music && music.length > 0) {
      if (value === 3) {
        history.push(`/app/MyNft/${music[index]["nftId"]}`);
      } else {
        let temp = [];
        music.forEach((element) => {
          if (
            !isOwnerId(element["uploader"] ? element["uploader"]["_id"] : "") &&
            !showError &&
            !element["isSubscribed"] &&
            element["private"]
          ) {
          } else {
            temp.push(element);
          }
        });
        let privateSongs = 0;
        let i = 0;
        for (i = 0; i <= index; i++) {
          if (
            !isOwnerId(
              music[i]["uploader"] ? music[i]["uploader"]["_id"] : ""
            ) &&
            !showError &&
            !music[i]["isSubscribed"] &&
            music[i]["private"]
          ) {
            privateSongs++;
          }
        }
        dispatch(
          addSongsAction(
            temp,
            false,
            null,
            index !== undefined ? index - privateSongs : 0
          )
        );
      }
    }
  };

  // Sync with parent data — sort by streams (most to least)
  React.useEffect(() => {
    if (initialMusic && initialMusic.length > 0) {
      const sorted = [...initialMusic].sort((a, b) => (b.listens ?? 0) - (a.listens ?? 0));
      setMusics(sorted);
    }
  }, [initialMusic]);

  React.useEffect(() => {
    if (initialPlaylists && initialPlaylists.length > 0) {
      setPlayLists(initialPlaylists);
    }
  }, [initialPlaylists]);

  React.useEffect(() => {
    if (initialNfts && initialNfts.length > 0) {
      setNftMusics(initialNfts);
    }
  }, [initialNfts]);

  React.useEffect(() => {
    if (initialAlbums && initialAlbums.length > 0) {
      setAlbums(initialAlbums);
    }
  }, [initialAlbums]);

  React.useEffect(() => {
    if (id && value == 1) {
      // Only load if we don't have data from parent
      if (tabIndex == 0 && singles.length === 0) {
        getSingles(1);
      } else if (tabIndex == 1 && albums.length === 0 && initialAlbums.length === 0) {
        getAlbums(1);
      }
    }
  }, [id, tabIndex, value]);

  const handleChange = (event, newValue) => {
    if (active === newValue) return;
    setActive(newValue);
    setValue(newValue);

    setPageNo(1);
    setMusics([]);
    setPlayLists([]);
    setNftMusics([]);

    // if (newValue === 0) {
    //   getMyMusic(pageNo);
    // } else {
    //   setLoaded(false);
    //   setPageNo(1);
    //   setMusics([]);
    // }

    switch (newValue) {
      case 0:
        history.push(`/app/artistProfile/${id}`);
        // getMyMusic(1);
        break;
      case 1:
        history.push(`/app/artistProfile/music/${id}`);
        // getPlayLists(1);
        break;
      case 2:
        history.push(`/app/artistProfile/studio/${id}`);
        // getPlayLists(1);
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (addBalance && addBalance === "addBalance") setValue(1);
  }, [addBalance]);

  // Sync internal value state with parent active state
  React.useEffect(() => {
    if (parentActive !== undefined && parentActive !== value) {
      setValue(parentActive);
    }
  }, [parentActive]);

  React.useEffect(() => {
    setValue(
      history.location.pathname.includes("music")
        ? 1
        : history.location.pathname.includes("studio")
        ? 2
        : 0
    );
    if (history.location.pathname.includes("music/albums")) {
      setTabIndex(1);
    } else {
      setTabIndex(0);
    }

    setActive(
      history.location.pathname.includes("music")
        ? 1
        : history.location.pathname.includes("studio")
        ? 2
        : 0
    );
  }, [history.location.pathname]);

  const handleScroll = async () => {
    // var a = target.scrollTop;
    // var b = target.scrollHeight - target.clientHeight;

    if (!loading) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      switch (active) {
        case 0:
          getMyMusic(next);
          break;
        case 1:
          // getMyMusic(next);
          tabIndex == 0 ? getSingles(next) : getAlbums(next);
          break;
        case 2:
          getPlayLists(next);
          break;
        default:
          break;
      }
      //   getMyMusic(next);
      //   getPlayLists(next);
      //   getNfts(next);
      //   getAlbum(next)
    }
  };

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          handleScroll();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );
  return (
    <Box>
      <Box sx={{ position: "relative" }}>
      <Tabs
        value={value}
        onChange={(event, newValue) => {
          if (parentHandleTabSwitch) {
            parentHandleTabSwitch(event, newValue);
          } else {
            setValue(newValue);
            setPageNo(1);
            if (newValue === 0 && musics.length === 0) {
              getMyMusic(1);
            } else if (newValue === 3 && playlists.length === 0) {
              getPlayLists(1);
            } else if (newValue === 4 && nftMusics.length === 0) {
              getNfts(1);
            }
          }
        }}
        TabIndicatorProps={{ style: { background: "#FFEE20", height: 2 } }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="artist content tabs"
        sx={{
          borderBottom: "1px solid rgba(255,255,255,0.04)",
          "& .MuiTabs-scroller": { borderBottom: "none" },
          "& .MuiTab-root": {
            color: "#444",
            fontWeight: 600,
            fontSize: "14px",
            textTransform: "none",
            minHeight: 52,
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            transition: "color 0.2s ease",
            "&:hover": { color: "#888" },
          },
          "& .Mui-selected": { color: "#FFEE20 !important" },
        }}
      >
        <Tab
          icon={
            <StarIcon
              sx={{
                fontSize: 18,
                color: value === 0 ? '#FFEE20' : '#666'
              }}
            />
          }
          label="Popular"
          {...a11yProps(0)}
        />
        <Tab
          icon={
            <svg
              width="14"
              height="14"
              viewBox="0 0 512 512"
              fill={value === 1 ? '#FFEE20' : '#666'}
            >
              <path d="M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"/>
            </svg>
          }
          label={
            isOwnerId(id)
              ? t("sidebar.menu2.menu1")
              : t("home.tabs.music.tab")
          }
          {...a11yProps(1)}
        />
        <Tab
          icon={
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill={value === 2 ? '#FFEE20' : '#666'}
            >
              <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
            </svg>
          }
          label="Gallery"
          {...a11yProps(2)}
        />
        <Tab
          icon={
            <QueueMusicIcon
              sx={{
                fontSize: 20,
                color: value === 3 ? '#FFEE20' : '#666'
              }}
            />
          }
          label={t("Playlists")}
          {...a11yProps(3)}
        />
        <Tab
          icon={<SensorsIcon sx={{ fontSize: 20, color: value === 4 ? '#FFEE20' : '#666' }} />}
          label="Live"
          {...a11yProps(4)}
        />
        <Tab
          icon={<VideocamIcon sx={{ fontSize: 20, color: value === 5 ? '#FFEE20' : '#666' }} />}
          label="Videos"
          {...a11yProps(5)}
        />
      </Tabs>


        <Box axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={value}>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box>
              <Stack spacing={0} sx={{ position: "relative" }}>
                {musics.length === 0 ? (
                  <Box sx={{ textAlign: "center", py: 8 }}>
                    <Typography sx={{ color: "#666", fontSize: 15 }}>No songs to display</Typography>
                    <Typography sx={{ color: "#444", fontSize: 13, mt: 1 }}>Music will appear here when uploaded</Typography>
                  </Box>
                ) : (
                  <Stack spacing={0}>
                    <table className="mymusic_table" style={{ tableLayout: "fixed", width: "100%" }}>
                      <thead
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: "1",
                          backgroundColor: "#0A0A0A",
                        }}
                      >
                        <tr>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "20px", width: "35%" }}>{t("trending.tabs.th1")}</th>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "20%" }}>
                            {t("trending.tabs.th2")}
                          </th>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "12%" }}>{t("trending.tabs.th3")}</th>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "18%" }}>{t("trending.tabs.th4")}</th>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", textAlign: "left", paddingLeft: "16px", width: "10%" }}>{t("trending.tabs.th5")}</th>
                          <th style={{ color: "#666", fontSize: 11, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid rgba(255,255,255,0.03)", width: "5%" }}>{t("trending.tabs.th6")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {musics.length > 0 ? (
                          musics.map((transaction, index) =>
                            index == musics.length - 1 ? (
                              <ArtistProfileRow
                                reference={lastBookElementRef}
                                lastIndex={index == musics.length - 1}
                                data={transaction}
                                value={value}
                                play={(e) => playAll(index, musics)}
                                actions={[
                                  { key: "m2", action: t("dropMenu.m2") },
                                  { key: "m3", action: t("dropMenu.m3") },
                                  { key: "m1", action: t("dropMenu.m1") },
                                ]}
                                toggleMenu={(action, id) =>
                                  action === "m8"
                                    ? toggleMenu(
                                        action,
                                        id,
                                        index,
                                        3,
                                        false,
                                        true
                                      )
                                    : toggleMenu(action, id, index, 0)
                                }
                                music={true}
                                uId={transaction}
                              />
                            ) : (
                              <ArtistProfileRow
                                lastIndex={index == musics.length - 1}
                                data={transaction}
                                value={value}
                                play={(e) => playAll(index, musics)}
                                actions={[
                                  { key: "m2", action: t("dropMenu.m2") },
                                  { key: "m3", action: t("dropMenu.m3") },
                                  { key: "m1", action: t("dropMenu.m1") },
                                ]}
                                toggleMenu={(action, id) =>
                                  action === "m8"
                                    ? toggleMenu(
                                        action,
                                        id,
                                        index,
                                        3,
                                        false,
                                        true
                                      )
                                    : toggleMenu(action, id, index, 0)
                                }
                                music={true}
                                uId={transaction}
                              />
                            )
                          )
                        ) : (
                          <NoData lable={t("noData.message20")} />
                        )}
                      </tbody>
                    </table>
                  </Stack>
                )}
              </Stack>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Box>
              <Stack direction="row" spacing={0} sx={{ borderBottom: "1px solid #1E1E1E", mb: 2 }}>
                <Box
                  onClick={() => {
                    setTabIndex(0);
                    history.push(`/app/ArtistProfile/music/${id}`);
                  }}
                  sx={{
                    padding: "12px 20px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                    color: tabIndex === 0 ? "#FFEE20" : "#666",
                    borderBottom: tabIndex === 0 ? "2px solid #FFEE20" : "2px solid transparent",
                    transition: "all 0.3s ease",
                    "&:hover": { color: tabIndex === 0 ? "#FFEE20" : "#aaa" },
                  }}
                >
                  Singles and EPs
                </Box>
                <Box
                  onClick={() => {
                    setTabIndex(1);
                    history.push(`/app/ArtistProfile/music/albums/${id}`);
                  }}
                  sx={{
                    padding: "12px 20px",
                    fontSize: "13px",
                    fontWeight: 600,
                    cursor: "pointer",
                    color: tabIndex === 1 ? "#FFEE20" : "#666",
                    borderBottom: tabIndex === 1 ? "2px solid #FFEE20" : "2px solid transparent",
                    transition: "all 0.3s ease",
                    "&:hover": { color: tabIndex === 1 ? "#FFEE20" : "#aaa" },
                  }}
                >
                  Albums
                </Box>
              </Stack>
              {(tabIndex == 0 && singles.length === 0) ||
              (tabIndex == 1 && albums.length === 0) ? (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography sx={{ color: "#666", fontSize: 15 }}>No songs to display</Typography>
                  <Typography sx={{ color: "#444", fontSize: 13, mt: 1 }}>
                    {tabIndex === 0 ? "Singles and EPs will appear here" : "Albums will appear here"}
                  </Typography>
                </Box>
              ) : (
                <ArtistMusicTab
                  history={history}
                  reference={lastBookElementRef}
                  play={(index, musics) => playAll(index, musics)}
                  actions={[
                    { key: "m2", action: t("dropMenu.m2") },
                    { key: "m3", action: t("dropMenu.m3") },
                    { key: "m1", action: t("dropMenu.m1") },
                  ]}
                  toggleMenu={(action, id, index) => {
                    action === "m8"
                      ? toggleMenu(action, id, index, 3, false, true)
                      : toggleMenu(action, id, index, 1);
                  }}
                  data={tabIndex == 0 ? singles : albums}
                />
              )}
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <ArtistGalleryTab userId={id} isOwner={isOwnerId(id)} />
          </TabPanel>
          <TabPanel value={value} index={3} dir={theme.direction}>
            <Box>
              {playlists.length === 0 ? (
                <Box sx={{ textAlign: "center", py: 8 }}>
                  <Typography sx={{ color: "#666", fontSize: 15 }}>No playlists to display</Typography>
                  <Typography sx={{ color: "#444", fontSize: 13, mt: 1 }}>Playlists will appear here when created</Typography>
                </Box>
              ) : (
                <Stack spacing={0} sx={{ position: "relative" }}>
                  <Stack spacing={0}>
                    <table className="mymusic_table" style={{ tableLayout: "fixed", width: "100%" }}>
                      <thead
                        style={{
                          position: "sticky",
                          top: "0",
                          zIndex: "1",
                          backgroundColor: "#0A0A0A",
                        }}
                      >
                        <tr>
                          <th style={{ color: "#666", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #1E1E1E", paddingLeft: "20px", width: "35%" }}>{t("trending.tabs.th8")}</th>
                          <th style={{ color: "#666", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #1E1E1E", textAlign: "left", paddingLeft: "16px", width: "25%" }}>
                            {t("trending.tabs.th2")}
                          </th>
                          <th style={{ color: "#666", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #1E1E1E", textAlign: "left", paddingLeft: "16px", width: "15%" }}>{t("trending.tabs.th3")}</th>
                          <th style={{ color: "#666", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #1E1E1E", textAlign: "left", paddingLeft: "16px", width: "15%" }}>{t("trending.tabs.th5")}</th>
                          <th style={{ color: "#666", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.5px", borderBottom: "1px solid #1E1E1E", width: "10%" }}>{t("trending.tabs.th6")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {playlists.length > 0 ? (
                          playlists.map((playlists, index) =>
                            index === playlists.length - 1 ? (
                              <ArtistProfileRow
                                reference={lastBookElementRef}
                                lastIndex={index == playlists.length - 1}
                                data={playlists}
                                value={value}
                                play={(e) => playAll(index, playlists)}
                                actions={[
                                  { key: "m26", action: t("dropMenu.m26") },
                                  { key: "m27", action: t("dropMenu.m27") },
                                  { key: "m8", action: t("dropMenu.m8") },
                                ]}
                                toggleMenu={(action, id) =>
                                  toggleMenu(action, id, index, 2, true)
                                }
                                isPlaylistNft={playlists.nftId ? true : false}
                                studio={true}
                              />
                            ) : (
                              <ArtistProfileRow
                                lastIndex={index == playlists.length - 1}
                                data={playlists}
                                value={value}
                                play={(e) => playAll(index, playlists)}
                                actions={[
                                  { key: "m26", action: t("dropMenu.m26") },
                                  { key: "m27", action: t("dropMenu.m27") },
                                  { key: "m8", action: t("dropMenu.m8") },
                                ]}
                                toggleMenu={(action, id) =>
                                  toggleMenu(action, id, index, 2, true)
                                }
                                isPlaylistNft={playlists.nftId ? true : false}
                                studio={true}
                              />
                            )
                          )
                        ) : (
                          <NoData lable={t("noData.message20")} />
                        )}
                      </tbody>
                    </table>
                  </Stack>
                </Stack>
              )}
            </Box>
          </TabPanel>
          <TabPanel value={value} index={4} dir={theme.direction}>
            {liveChannelName && (
              <Box
                onClick={() => history.push(`/app/LiveVideoStreaming/${liveChannelName}`)}
                sx={{
                  display: "flex", alignItems: "center", gap: 1.5, cursor: "pointer",
                  m: 2, p: 2, borderRadius: "10px",
                  border: "1px solid rgba(255,238,32,0.35)", background: "rgba(255,238,32,0.06)",
                }}
              >
                <SensorsIcon sx={{ color: "#FFEE20" }} />
                <Typography sx={{ color: "#fff", fontWeight: 700 }}>Live now</Typography>
                <Typography sx={{ color: "#888", fontSize: 13 }}>Tap to watch the stream</Typography>
              </Box>
            )}
            <MyLivestreamsTab userId={id} readOnly={!isOwnerId(id)} />
          </TabPanel>
          <TabPanel value={value} index={5} dir={theme.direction}>
            <MyVideosTab userId={id} readOnly={!isOwnerId(id)} />
          </TabPanel>
        </Box>
      </Box>
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {loading ? <Loader /> : null}
    </Box>
  );
}
